/* --------------------------------------------------------------------------------------
   scanBrowse.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const scanBrowseComponent = {
  template: `
    <div class="main-container">
      <div class="content-container" ng-show="vm.node">
        <action-bar id="scan-browse-action-bar" title="{{ 'BROWSE' | translate }}" ok="vm.ok()" cancel="vm.cancel()" disable-ok="!vm.isFolderOrMatter()"></action-bar>
        <browser search-enabled="false" node="vm.node" matter="vm.matter" selection-type="folder"></browser>
      </div>
    </div>
    `,
  controllerAs: "vm",
  controller: class scanBrowseController {
    /* @ngInject */
    constructor(commonService, sessionDataService, $state) {
      this.$state = $state;
      this.commonService = commonService;
      this.sessionDataService = sessionDataService;
    }
    $onInit() {}
    isFolderOrMatter() {
      return (
        this.node &&
        (this.node.EntryType == "Folder" || this.node.EntryType == "matter")
      );
    }
    ok() {
      this.sessionDataService.scanFolder = this.node;
      this.sessionDataService.matter = this.matter;
      this.$state.go("scanSettings");
    }
    cancel() {
      this.$state.go(this.sessionDataService.lastOp);
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/scan/components/scanBrowse.component.js